import React from 'react';
import PropTypes from 'prop-types';
// import axios from 'axios';
import { cardDocImg as CardDocImg } from 'theme/icon';

import styles from '../styles.scss';

export default class FilesLog extends React.PureComponent {
  static propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    files: PropTypes.arrayOf(PropTypes.object).isRequired,
    actionId: PropTypes.number.isRequired,
  };

  render() {
    const { files, actionId } = this.props;

    // const loadFile = xURL => {
    //   axios({
    //     url: xURL,
    //     method: 'GET',
    //     responseType: 'blob',
    //   }).then(response => {
    //     const url = window.URL.createObjectURL(new Blob([response.data]));
    //     const link = document.createElement('a');
    //     link.href = url;
    //     link.setAttribute('download', 'file.pdf');
    //     document.body.appendChild(link);
    //     link.click();
    //   });
    // };
    return (
      <div className={styles.files}>
        {files &&
          files.map(f => (
            <div className={styles.row}>
              <div className={styles.icon}>
                <CardDocImg alt="" />
                <div className={styles.extension}>{f.ext}</div>
              </div>

              {f.hash && (
                // <div
                //   className={styles.name}
                //   onClick={() => loadFile(`/doc/${f.hash}/${f.name}/${f.ext}`)}
                // >
                //   {f.name}
                // </div>
                <a className={styles.name} href={`/tender/doc/${f.hash}/${encodeURIComponent(f.name)}/${f.ext}`}>
                  {f.name}
                </a>
              )}
              {(actionId === 6 || !f.hash) && (
                <div className={styles.name}>
                  <div>{f.name}</div>
                  {actionId === 5 && <div className={styles.del}>Документ удален</div>}
                </div>
              )}
            </div>
          ))}
      </div>
    );
  }
}
